import { render, staticRenderFns } from "./notifySetting.vue?vue&type=template&id=1b1b9132&scoped=true"
import script from "./notifySetting?vue&type=script&lang=js&external"
export * from "./notifySetting?vue&type=script&lang=js&external"
import style0 from "./notifySetting.vue?vue&type=style&index=0&id=1b1b9132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1b9132",
  null
  
)

export default component.exports